var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_28006)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_311_28006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1305 37.9897C32.7491 39.1856 33.4398 40.3093 34.2027 41.3608C34.9862 42.433 35.8316 43.4278 36.7388 44.3454C37.646 45.2629 38.6254 46.1031 39.6769 46.866C40.7079 47.6289 41.8006 48.3093 42.9553 48.9072L43.1099 48.9691L46.7594 45.2887C46.9862 45.1443 47.2542 45.0464 47.5635 44.9948C47.8728 44.9433 48.1718 45.1134 48.4604 45.5052C49.3883 45.5052 50.4759 45.5619 51.7233 45.6753C52.9707 45.7887 53.8625 45.8454 54.3986 45.8454C54.8522 45.8454 55.2439 46.0052 55.5738 46.3247C55.9037 46.6443 56.0687 47.0309 56.0687 47.4845V53.3299C56.0687 53.7835 55.9037 54.1753 55.5738 54.5052C55.2439 54.8351 54.8522 55 54.3986 55C50.4811 55 46.8109 54.2577 43.3883 52.7732C39.945 51.2887 36.9398 49.2629 34.3728 46.6959C31.8058 44.1289 29.78 41.134 28.2955 37.7113C26.8316 34.268 26.0996 30.5876 26.0996 26.6701C26.0996 26.2165 26.2594 25.8247 26.579 25.4948C26.8986 25.1649 27.2852 25 27.7388 25H33.5841C34.0378 25 34.4295 25.1649 34.7594 25.4948C35.0893 25.8247 35.2542 26.2165 35.2542 26.6701C35.2542 27.7216 35.3316 28.7423 35.4862 29.732C35.6408 30.7216 35.8728 31.6907 36.1821 32.6392C36.2852 32.9072 36.3006 33.3402 36.2285 33.9381C36.1563 34.5361 36.0068 34.6598 35.78 34.3093L32.1305 37.9897Z",
    fill: "url(#paint0_linear_311_28006)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_311_28006",
    x: 11.0996,
    y: 14,
    width: 59.9688,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_311_28006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_311_28006",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_28006",
    x1: 26.0996,
    y1: 40,
    x2: 56.0687,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0B3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#107650"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_28006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(1 0 0 -1 20 60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contact_phone.45890a29a7f1fa195b9d654adfdbc4b4.svg";
export { ForwardRef as ReactComponent };